import { render } from "./TermsConditions.vue?vue&type=template&id=58a3efab&scoped=true"
import script from "./TermsConditions.vue?vue&type=script&lang=js"
export * from "./TermsConditions.vue?vue&type=script&lang=js"

import "./TermsConditions.vue?vue&type=style&index=0&id=58a3efab&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a3efab"]])

export default __exports__